module.exports = __webpack_public_path__ + "img/backyard-planter.fe57f215.webp";